
import {
    Button,
    Card,
    Grid,
    InputAdornment,
    Table,
    TableContainer,
    TableHead,
    TextField,
    Typography,
    TableRow,
    TableBody,
    Box,
    TablePagination,
    Divider,
    FormControl,
    Select,
    MenuItem,
    ListSubheader,
    TableCell,
    Tooltip,

} from '@mui/material';
import { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import { withStyles } from '@mui/styles';
import { TableHeaderCell } from 'src/components/TableHeaderCell';
import { TableColumnCell } from 'src/components/TableColumnCell';
import { DatePicker } from '@mui/lab';
import moment from 'moment';
import { getAttendeeEvents } from "src/services/EventService";
import { getAllEmployeesFilter } from 'src/services/employeeService';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PreviewToggleModal from 'src/content/event/PreviewToggleModel';
import { useParams } from 'react-router-dom';



const ViewEvent = () => {
    const navigate = useNavigate();

    const [events, setEvents] = useState([]);
    const [searchString, setSearchString] = useState('');
    const [toggleFilter, setToggleFilter] = useState(false);
    const [filterEventDate, setFilterEventDate] = useState<string | null>(null);
    const [filterFacilitator, setFilterFacilitator] = useState('');
    const [facilitatorList, setFacilitatorList] = useState([]);
    const [recordCount, setRecordCount] = useState<number>(0);
    const [page, setPage] = useState<number>(0);
    const [limit, setLimit] = useState<number>(10);
    const [isFilterDisabled, setIsFilterDisabled] = useState(true);
    const [isFilterCleared, setIsFilterCleared] = useState(false);
    const [searchText, setSearchText] = useState('');
    const [isClearingFilters, setIsClearingFilters] = useState(false);

    const [previewOpen, setPreviewOpen] = useState(false);
    const [eventId, setEventId] = useState(0);
    const previewToggle = () => setPreviewOpen(false);
    const params = useParams();
    const employeeId = params.employeeId;


    const filteredFacilitators = facilitatorList.filter((item) =>
        item.name.toLowerCase().includes(searchText.toLowerCase())
    );


    const currentYear = new Date().getFullYear();

    useEffect(() => {
        if (isClearingFilters) {
            getEventList();
            setIsClearingFilters(false);
        }
    }, [filterFacilitator, filterEventDate, isClearingFilters]);


    useEffect(() => {
        fetchFacilitators();
        getEventList();
    }, [page, limit, searchString]);

    const fetchFacilitators = async () => {
        try {
            const res = await getAllEmployeesFilter([], []);
            const employees = Array.isArray(res.data.employees) ? res.data.employees : [];
            setFacilitatorList(employees);
        } catch {
            setFacilitatorList([]);
        }
    };

    const getEventList = () => {
        const filterPayload = {
            pageNo: page,
            pageSize: limit,
            eventName: searchString,
            facilitator: filterFacilitator,
            date: filterEventDate,
            selectedEmployeeId: employeeId
        };


        getAttendeeEvents(filterPayload)
            .then((res) => {

                if (res?.data?.statusCode === 200) {
                    setEvents(res?.data?.data?.events || []);
                    setRecordCount(res?.data?.data?.totalCount || 0);
                } else {
                    setEvents([]);
                }
            })
            .catch(() => setEvents([]));
    };
    useEffect(() => {
        if (isFilterCleared) {
            getEventList();
        }
        setIsFilterCleared(false);
    }, [filterEventDate, filterFacilitator]);


    const onClear = () => {
        setFilterEventDate('');
        setFilterFacilitator('');
        setPage(0);
        setIsFilterCleared(true);
        setIsFilterDisabled(true);
    };

    const onFilter = () => {
        setPage(0);
        getEventList();
    };

    const handlePageChange = (event: any, newPage: number): void => {
        setPage(newPage);
    };

    const handleLimitChange = (event: ChangeEvent<HTMLInputElement>): void => {
        setPage(0);
        setLimit(parseInt(event.target.value));
    };

    const formatTo12Hour = (time: String) => {
        const [hours, minutes] = time.split(":");
        const date = new Date();
        date.setHours(Number(hours), Number(minutes));

        const options: Intl.DateTimeFormatOptions = {
            hour: "2-digit",
            minute: "2-digit",
            hour12: true,
        };

        return date.toLocaleTimeString("en-US", options);
    };

    function convertToDDMMYYYY(dateStr: string): string {
        const [year, month, day] = dateStr.split('-');
        return `${day}/${month}/${year}`;
    }

    const CustomTableRow = withStyles({
        root: {
            background: '#E6E9FF !important',
            height: '3.5rem'
        }
    })(TableRow);

    return (
        <Grid>


            <Card>
                <Grid sx={{ m: 2 }}>
                    <TextField
                        sx={{ width: 320, mr: 2 }}
                        size="small"
                        placeholder="Search Event Name"
                        InputProps={{
                            style: { fontSize: '12px', height: '1.75rem' },
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon
                                        sx={{ color: '#d3d3d3' }}
                                        style={{ fontSize: '15px' }}
                                    />
                                </InputAdornment>
                            )
                        }}
                        inputProps={{
                            maxLength: 255
                        }}
                        value={searchString}
                        onChange={(e) => {
                            setSearchString(e.target.value);
                        }}
                    />
                    <Button
                        sx={{
                            mt: { xs: 2, md: 0 },
                            color: `${!toggleFilter && 'gray'}`
                        }}
                        variant="outlined"
                        startIcon={<FilterListIcon style={{ fontSize: '15px' }} />}
                        style={{ height: '1.75rem', fontSize: '12px' }}
                        onClick={() => {
                            setToggleFilter(!toggleFilter);
                        }}
                    >
                        Filters
                    </Button>
                </Grid>
                {toggleFilter && (
                    <Grid px={2} pb={2} style={{ margin: 0 }}>
                        <Grid
                            container
                            spacing={2}
                            style={{
                                paddingTop: 2,
                                paddingBottom: 2,
                                justifyContent: 'between'
                            }}
                        >
                            <Grid item xs={3}>
                                <div style={{ marginTop: 7 }}>
                                    <FormControl fullWidth>
                                        <DatePicker
                                            InputProps={{
                                                className: 'date-picker-leaveManagement'
                                            }}
                                            maxDate={new Date(currentYear, 11, 31)}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    inputProps={{
                                                        ...params.inputProps,
                                                        placeholder: 'Event Date',
                                                    }}
                                                />
                                            )}
                                            value={filterEventDate ? filterEventDate : null}
                                            onChange={(newValue) => {
                                                if (newValue) {
                                                    setFilterEventDate(moment(newValue).format('YYYY-MM-DD'));
                                                    setIsFilterDisabled(false);
                                                }
                                            }}
                                        />
                                    </FormControl>
                                </div>
                            </Grid>
                            <Grid item xs={3}>
                                <FormControl fullWidth>
                                    <Select
                                        sx={{ mt: 1 }}
                                        style={{
                                            fontSize: '12px',
                                            height: '2rem'
                                        }}
                                        fullWidth
                                        value={filterFacilitator || ' '}
                                        onChange={(e) => {
                                            setFilterFacilitator(e.target.value);
                                            setIsFilterDisabled(false);
                                        }}
                                        onClose={() => setSearchText('')}
                                        displayEmpty
                                    >
                                        <ListSubheader>
                                            <TextField
                                                autoFocus
                                                placeholder="Type to search..."
                                                size="small"
                                                fullWidth
                                                value={searchText}
                                                onChange={(e) => setSearchText(e.target.value)}
                                                onKeyDown={(e) => {
                                                    if (e.key !== 'Escape') {
                                                        e.stopPropagation();
                                                    }
                                                }}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <SearchIcon fontSize="small" />
                                                        </InputAdornment>
                                                    ),
                                                    style: {
                                                        fontSize: '12px',
                                                        height: '32px',
                                                    },
                                                }}
                                            />
                                        </ListSubheader>
                                        <MenuItem
                                            style={{ display: 'none' }}
                                            value=" "
                                            disabled
                                            hidden
                                        >
                                            <span style={{ color: '#a4a9b7' }}>
                                                Facilitator
                                            </span>
                                        </MenuItem>
                                        {filteredFacilitators.map((item) => {
                                            return (
                                                <MenuItem value={item.name} key={item.id}>
                                                    {item.name}
                                                </MenuItem>
                                            );
                                        })}
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid
                                item
                                xs={9}
                                style={{
                                    display: 'flex',
                                    justifyContent: 'flex-end',
                                    marginLeft: 'auto'
                                }}
                            >
                                <Button
                                    variant="outlined"
                                    style={{
                                        height: '1.75rem',
                                        fontSize: '12px'
                                    }}
                                    id="filterClear"
                                    disabled={isFilterDisabled}
                                    className={isFilterDisabled && 'clear-btn'}
                                    onClick={() => onClear()}
                                >
                                    Clear
                                </Button>
                                <Button
                                    id="filterSubmit"
                                    variant="outlined"
                                    type="button"
                                    style={{
                                        height: '1.75rem',
                                        fontSize: '12px',
                                        marginLeft: '1rem'
                                    }}
                                    onClick={() => onFilter()}
                                    disabled={isFilterDisabled}
                                    className={isFilterDisabled && 'filter-btn'}
                                >
                                    Filter
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>
                )}

                <Divider />
                <Box sx={{ width: '100%', overflowX: 'auto' }}></Box>
                <TableContainer>
                    <Table size="small" sx={{ minWidth: '1000px', tableLayout: 'auto' }}>

                        <TableHead>
                            <CustomTableRow>
                                <TableHeaderCell content="Event Name" smallFont />
                                <TableHeaderCell content="Date" smallFont />
                                <TableHeaderCell content="Time" smallFont />
                                <TableHeaderCell content="Audience" smallFont />
                                <TableHeaderCell content="Facilitator" smallFont />
                                <TableHeaderCell content="Venue" smallFont />
                                <TableHeaderCell content="Participation" smallFont />
                                <TableHeaderCell content="Action" smallFont sticky justifyContent />


                            </CustomTableRow>
                        </TableHead>
                        <TableBody>
                            {events.map((item) => (
                                <TableRow key={item.id} sx={{ height: '3rem', verticalAlign: 'middle' }}>
                                    <TableColumnCell>
                                        <Box
                                            sx={{
                                                fontSize: '11px',
                                                maxWidth: '160px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                        >
                                            {item.eventName}
                                        </Box>
                                    </TableColumnCell>

                                    <TableColumnCell><Box sx={{ fontSize: '11px' }}>{convertToDDMMYYYY(item.date)}</Box></TableColumnCell>
                                    <TableColumnCell><Box sx={{ fontSize: '11px' }}>{formatTo12Hour(item.time)}</Box></TableColumnCell>
                                    <TableColumnCell>
                                        <Box
                                            sx={{
                                                fontSize: '11px',
                                                maxWidth: '140px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                        >
                                            {item.audience}
                                        </Box>
                                    </TableColumnCell>

                                    <TableColumnCell><Box sx={{ fontSize: '11px' }}>{item.facilitator || 'N/A'}</Box></TableColumnCell>
                                    <TableColumnCell>
                                        <Box
                                            sx={{
                                                fontSize: '11px',
                                                maxWidth: '140px',
                                                whiteSpace: 'nowrap',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                        >
                                            {item.venue}
                                        </Box>
                                    </TableColumnCell>


                                    <TableColumnCell>
                                        <Box
                                            sx={{
                                                fontSize: '11px',
                                                px: 1.2,
                                                py: 0.3,
                                                borderRadius: '10px',
                                                display: 'inline-block',
                                                backgroundColor:
                                                    item.participation === 'Facilitator'
                                                        ? '#2196F3'
                                                        : item.participation === 'Present'
                                                            ? '#4CAF50'
                                                            : item.participation === 'Absent'
                                                                ? '#f44336'
                                                                : '#bdbdbd',
                                                color: '#fff',
                                                fontWeight: 500,
                                                textAlign: 'center',
                                                minWidth: '60px'
                                            }}
                                        >
                                            {item.participation || 'N/A'}
                                        </Box>
                                    </TableColumnCell>

                                    <TableCell
                                        sx={{
                                            position: 'sticky',
                                            right: 0,
                                            background: '#fff',
                                            zIndex: 999,
                                            width: '60px',
                                            minWidth: '60px',
                                            maxWidth: '60px',
                                            borderLeft: '1px solid #dce6f1'

                                        }}
                                    >
                                        <Box display="flex" alignItems="center" justifyContent="center">
                                            <Tooltip title="View Event" placement="top">
                                                <VisibilityIcon
                                                    onClick={() => {
                                                        setEventId(item?.id);
                                                        setPreviewOpen(true);
                                                    }}
                                                    style={{
                                                        fontSize: '17px',
                                                        cursor: 'pointer',
                                                        marginRight: '10px'
                                                    }}
                                                />
                                            </Tooltip>
                                        </Box>
                                    </TableCell>


                                </TableRow>
                            ))}
                        </TableBody>


                    </Table>
                    {events.length === 0 && (
                        <Typography textAlign="center" fontWeight="bold" m={2}>No Events Found</Typography>
                    )}
                </TableContainer>


                <Box p={2}>
                    <TablePagination
                        sx={{
                            fontSize: '12px',
                            '.MuiTablePagination-displayedRows': {
                                fontSize: '12px'
                            },
                            '.MuiTablePagination-selectLabel': {
                                fontSize: '12px'
                            }
                        }}
                        component="div"
                        count={recordCount}
                        onPageChange={handlePageChange}
                        onRowsPerPageChange={handleLimitChange}
                        page={page}
                        rowsPerPage={limit}
                        rowsPerPageOptions={[10, 20, 30, 40, 50]}
                    />
                </Box>
            </Card>
            <PreviewToggleModal
                previewOpen={previewOpen}
                previewToggle={previewToggle}
                eventId={eventId}
            />
        </Grid>

    );
};

export default ViewEvent;
